export const DEFAULT_MAP_BOUNDS = [187.18172, 82.68953, -169.8938, -72.0973];
